import React, { useEffect, useState, useRef } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app, auth } from '../firebaseConfig';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import DOMPurify from 'dompurify';  // DOMPurifyのインポート
import MenuBar from '../components/MenuBar';
import '../styles/Inbox.css';
import AddToHomeScreen from '../components/AddToHomeScreen';
import { BsThreeDots } from "react-icons/bs";



const Inbox = () => {
  const [user] = useAuthState(auth);
  const [chats, setChats] = useState([]);
  const [isAgeVerified, setIsAgeVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const menuRef = useRef(null); // メニュー領域の参照を作成
  const [isPaidUser, setIsPaidUser] = useState(false);


  useEffect(() => {
    if (user) {
      const functions = getFunctions(app, 'asia-northeast2');
      const fetchChatsWithLastMessage = httpsCallable(functions, 'fetchChatsWithLastMessage');
  
      fetchChatsWithLastMessage()
        .then(async (result) => {
          setChats(result.data.chats);
          setIsAgeVerified(result.data.isAgeVerified);
  
          // 🔽 有料ユーザー判定を追加
          const paySnap = await getDoc(doc(db, 'pay_checked', user.uid));
          if (paySnap.exists()) {
            const expiration = paySnap.data().expiration?.toDate?.();
            setIsPaidUser(expiration && expiration > new Date());
          } else {
            setIsPaidUser(false);
          }
  
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching chats:', error);
          setLoading(false);
        });
    }
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  

  const truncateMessage = (text) => {
    if (!text) return "";
    return text.length > 35 ? sanitize(text.slice(0, 35)) + '...' : sanitize(text);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';

    const date = timestamp._seconds ? new Date(timestamp._seconds * 1000) : new Date(timestamp);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0'); 

    return `${year}/${month}/${day}`;
  };

  const getChatDate = (chat) => {
    if (chat.lastMessage && chat.lastMessage.createdAt) {
      return new Date(chat.lastMessage.createdAt._seconds * 1000 + chat.lastMessage.createdAt._nanoseconds / 1000000);
    }
    if (chat.createdAt && chat.createdAt._seconds) {
      return new Date(chat.createdAt._seconds * 1000 + chat.createdAt._nanoseconds / 1000000);
    }
    return new Date(0);
  };

  const sanitize = (input) => {
    return DOMPurify.sanitize(input); // DOMPurifyを使って入力をサニタイズ
  };

  const [showMenu, setShowMenu] = useState(false);
const toggleMenu = () => setShowMenu(!showMenu);


  if (loading) {
    return <div></div>;
  }

  return (
    <div className="inbox-container">
      <div className="settings-header">
  <div className="bell-icon-link-x" ref={menuRef}>
    <BsThreeDots className="bell-icon" onClick={toggleMenu} />
    {showMenu && (
      <div className="dropdown-menu-inbox">
        <button onClick={() => window.location.href = '/settingpush'}>通知設定</button>
        <button onClick={() => window.location.href = '/chat-not-display'}>非表示一覧</button>
      </div>
    )}
  </div>
  <p className="settings-title">メッセージ</p>
</div>


{/* 👇 まだメッセージのやりとりがないマッチング相手 */}
{chats.some(chat => !chat.lastMessage && chat.participantData) && (
  <div className="matched-users-container">
    <p className="matched-user-top">マッチング済みのユーザー</p>
    <div className="matched-users-scroll">
      {chats
        .filter((chat) => !chat.lastMessage)
        .map((chat) => {
          const participantData = chat.participantData;
          if (!participantData) return null;

          return (
            <Link to={`/chat/${chat.id}`} key={chat.id} className="matched-user-item">
              <img
                src={participantData.photoURL || '/images/default.png'}
                alt="profile"
                className="matched-user-avatar"
              />
              <p className="matched-user-name">{participantData.age}歳 / {participantData.location}</p>
            </Link>
          );
        })}
    </div>
  </div>
)}









{/* 💬 メッセージを送ったことがないマッチングが存在するが、やりとりがまだ無い場合に表示 */}
{chats.filter(chat => !chat.lastMessage && chat.participantData).length > 0 &&
 chats.filter(chat => chat.lastMessage).length === 0 && (
  <div className="no-chat-message">
    メッセージがありません
  </div>
)}

<ul className="chat-list">
  {chats
    .filter((chat) => chat.lastMessage)
    .sort((a, b) => {
      const dateA = getChatDate(a);
      const dateB = getChatDate(b);
      return dateB - dateA;
    })
    .map(chat => {
      const participantData = chat.participantData;
      const lastMessage = chat.lastMessage;
      const unreadCount = chat.unreadCount || 0;

      return (
        <li key={chat.id} className="chat-item">
          <Link to={`/chat/${chat.id}`} className="chat-link">
            <img src={participantData?.photoURL || '/images/default.png'} alt="Profile" className="chat-avatar" />
            <div className="chat-info">
              <div className="chat-header">
                <h3 className="chat-name">
                  {sanitize(participantData?.name || '--')}
                </h3>
                <span className="chat-date">
                  {formatDate(lastMessage.createdAt)}
                </span>
              </div>
              <div className="chat-body">
              <p className="chat-last-message">
  {isAgeVerified && isPaidUser
    ? (lastMessage.imageUrl ? '画像が送信されました' : truncateMessage(lastMessage.text))
    : !isAgeVerified
      ? '年齢確認が必要です'
      : '有料会員の登録が必要です'}
</p>

                {unreadCount > 0 && (
                  <div className="unread-badge-a">{unreadCount}</div>
                )}
              </div>
            </div>
          </Link>
        </li>
      );
    })}
</ul>


      <MenuBar />
    </div>
  );
};

export default Inbox;
